import React, { createContext } from 'react';
import { db, auth } from '../firebase';

export const FirebaseContext = createContext(null);

export const FirebaseProvider = ({ children }) => (
  <FirebaseContext.Provider value={{ db, auth }}>
    {children}
  </FirebaseContext.Provider>
);